<template>
  <Dialog :open="open" @update:open="$emit('update:open', $event)">
    <DialogContent>
     <DialogHeader>
        <DialogTitle>Create team</DialogTitle>
        <DialogDescription>
          Create a new team to collaborate with others.
        </DialogDescription>
      </DialogHeader>


     <form class="space-y-4" @submit="onSubmit">
        <FormField v-slot="{ componentField, meta }" name="name" >
          <FormItem >
            <FormLabel>Name</FormLabel>
            <FormControl>
              <Input type="text" placeholder="Acme" v-bind="componentField" />
            </FormControl>
            <FormMessage />
          </FormItem>
        </FormField>

        <DialogFooter>
          <Button :loading="loading" :disabled="loading" type="submit">Save</Button>
        </DialogFooter>
      </form>

    </DialogContent>
  </Dialog>
</template>

<script lang="ts" setup>
import { z } from "zod"
import { toTypedSchema } from '@vee-validate/zod';
import { useForm } from 'vee-validate';
import { FormField } from "@/components/ui/form";
import { AxiosError } from "axios";
import { toast } from "vue-sonner";

const { pushEvent } = useGtm();

defineProps<{ open: boolean }>()
const emit = defineEmits(['update:open', 'team-created']);


const formSchema = toTypedSchema(
  z.object({
    name: z.string().optional().refine(
  val => !val || val.length >= 3,
  { message: "Name must be at least 3 characters" }
)
  })
)

const { handleSubmit } = useForm({
  validationSchema: formSchema,
  initialValues: {
    name: "",
  },
  validateOnMount: false,
})

const loading = ref(false);

const onSubmit = handleSubmit(async (values) => {
  loading.value = true

  try {
    const formData = values // or construct your form data

    await axios.post(route('teams.store'), formData)

    emit('team-created');

    pushEvent('topolpro_create_team')

    toast.success("Team created!", {
      description: "Your team has been successfully created.",
    })

    emit("update:open", false)

  } catch (err) {
    if (err instanceof AxiosError) {
      errors.value = err.response?.data.errors
    }
  } finally {
    loading.value = false
  }
})

</script>
